// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"EditableHoverEffect_inputBox__3kEgE","editIcon":"EditableHoverEffect_editIcon__2phBr"};